import React, { useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Card, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function BusinessUserIndividualizedCourses() {
  const { t } = useTranslation("BusinessUserIndividualizedCourses");
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTrails, setActiveTrails] = useState([]);

  const handleCheckboxChange = (id) => {
    // Check if the checkbox is already active
    if (activeTrails.includes(id)) {
      // If it's active, remove it from the list
      setActiveTrails(activeTrails.filter((trailId) => trailId !== id));
    } else {
      // If not, check if we can add it
      if (activeTrails.length < 2) {
        setActiveTrails([...activeTrails, id]);
      }
    }
  };

  const trailsData = [
    {
      id: 1,
      title: t("targeted_skill_development_title"),
      description: t("targeted_skill_development_description"),
      imageSrc: "/png/trails1.png",
    },
    {
      id: 2,
      title: t("increased_employee_engagement_title"),
      description: t("increased_employee_engagement_description"),
      imageSrc: "/png/trails2.png",
    },
    {
      id: 3,
      title: t("enhanced_productivity_title"),
      description: t("enhanced_productivity_description"),
      imageSrc: "/png/trails3.png",
    },
    {
      id: 4,
      title: t("better_retention_of_knowledge_title"),
      description: t("better_retention_of_knowledge_description"),
      imageSrc: "/png/trails4.png",
    },
    {
      id: 5,
      title: t("flexibility_and_adaptability_title"),
      description: t("flexibility_and_adaptability_description"),
      imageSrc: "/png/trails5.png",
    },
    {
      id: 6,
      title: t("stronger_organizational_culture_title"),
      description: t("stronger_organizational_culture_description"),
      imageSrc: "/png/trails6.png",
    },
  ];

  const handleNavigate = (to) => {
    if (to === "activate") {
      navigate("/business-blended-learning", {
        state: {
          name: location?.state?.name,
          plan: location?.state?.plan,
          userPlan: location?.state?.userPlan,
          courseTrails: location?.state?.courseTrails,
          supportPlan: location?.state?.supportPlan,
          sharedCourses: location?.state?.sharedCourses,
          // individualizedCourses: {
          //     name: "Completely Individualized Courses for Your Company and Industry",
          //     amount: 10000,
          //     additional: 10,
          // },
        },
      });
    } else {
      navigate("/business-user-payment", {
        state: {
          name: location?.state?.name,
          plan: location?.state?.plan,
          userPlan: location?.state?.userPlan,
          courseTrails: location?.state?.courseTrails,
          supportPlan: location?.state?.supportPlan,
          sharedCourses: location?.state?.sharedCourses,
          blendedLearning: [],
        },
      });
      // navigate("/business-home");
    }
  };

  return (
    <>
      <Header />
      <section className="payment-flow-section">
        <div className="container">
          <div className="available-trails pb-0 pb-lg-5 pt-0">
            <div className="row">
              <div className="col-12 col-xl-8">
                <h3 className="welcome-title max-width-100">
                  {t("individualized_courses_title")}
                </h3>
              </div>
            </div>
            <p className="welcome-description plan-description">
              {t("customized_courses_description")}
            </p>

            <h2 className="text-black fw-500"> {t("pricing")} </h2>
            <div>
              <h4 className="fw-300 text-black mb-3">
                {t("initialsetup")} :{" "}
                <span className="fs-2 fw-500">
                  €10,000 <span className="fw-400">{t("peryear")} </span>
                </span>
              </h4>
              <h4 className="fw-300 text-black ">
                {t("additional")} :{" "}
                <span className="fs-2 fw-500">
                  €10 <span className="fw-400">{t("peremployeeperyear")}</span>
                </span>
              </h4>
            </div>
            <form className="row form-main payment-buttons my-4 my-md-5">
              <div className="col-md-12">
                <div className="d-md-flex align-items-center gap-3">
                  <button
                    type="button"
                    className="btn-primary rounded-2 fw-400"
                    onClick={() => handleNavigate("activate")}
                  >
                    {t("activateindividualizedcourses")}
                  </button>

                  <button
                    className="btn-explore rounded-2 fw-400 d-inline-block mt-3 mt-md-0"
                    onClick={() => handleNavigate("skip")}
                  >
                    {t("skiptopaymentdetails")}
                  </button>
                </div>
              </div>
            </form>
            <h2 className="fw-500 text-black">
              {t("customCoursesBenefits")}
            </h2>
            <Row className="available-trails-cards g-3 pt-4 individualized-courses">
              {trailsData.map((trail) => (
                <Col key={trail.id} md={6} xl={4}>
                  <Card className="bg-transparent shadow-none border-0">
                    <Card.Body className="p-0">
                      <img
                        className="m-auto d-flex"
                        width={130}
                        height={130}
                        src={trail.imageSrc}
                        alt={trail.title}
                      />
                      <div>
                        <h5>{trail.title}</h5>
                        <p>{trail.description}</p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default BusinessUserIndividualizedCourses;
